import lang from '@/lang/middleware/products/mortgage';

export default ({ route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const prefix = route.path.match(/lifetime-loans/) ? 'index.lifetime-loans' : 'index';
  store.commit('jumbotron/SET_JUMBOTRON', {
    subtitle: store.$i18n.t(`${prefix}.jumbotron.subtitle`),
    title: store.$i18n.t(`${prefix}.jumbotron.title`),
    type: 'generic'
  });
  store.commit('pageContent/setHead', { description: store.$i18n.t(`${prefix}.description`), title: store.$i18n.t(`${prefix}.title`) });
};
